import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const CompanyAuth = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    companyName: '',
    contactPerson: '',
    phoneNumber: '',
    address: '',
    vatId: '',
    fleetSize: '',
    serviceAreas: '',
    website: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const advertId = location.state?.advertId;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const url = isLogin
      ? 'https://dropquote.co.za/backend/company_login.php'
      : 'https://dropquote.co.za/backend/company_register.php';

    const payload = isLogin
      ? { email: formData.email, password: formData.password }
      : formData;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const text = await response.text();
      console.log(`${isLogin ? 'Login' : 'Register'} response status:`, response.status, 'Raw response:', text);

      if (!response.ok) {
        throw new Error(`Server error: ${response.status} - ${text}`);
      }

      let result;
      try {
        result = JSON.parse(text);
      } catch (jsonError) {
        throw new Error(`Invalid JSON response: ${text}`);
      }

      // Modified condition to check for companyId
      if (result.success && result.data && result.data.id) {
        const companyId = parseInt(result.data.id, 10);
        if (isNaN(companyId) || companyId <= 0) {
          throw new Error('Invalid company ID received from server');
        }
        localStorage.setItem('companyAuthenticated', 'true');
        localStorage.setItem('companyId', companyId);
        localStorage.setItem('role', result.role || 'user');
        console.log(`${isLogin ? 'Login' : 'Registration'} successful, companyId set:`, companyId);
        alert(isLogin ? 'Login successful!' : 'Registration successful!');
      
        if (result.role === 'admin') {
          navigate('/admin');
        } else if (advertId) {
          navigate('/apply', { state: { advertId } });
        } else {
          navigate('/');
        }
      } else {
        throw new Error(result.message || 'Authentication failed');
      }
    } catch (error) {
      console.error('Auth error:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Rest of the component remains unchanged
  return (
    <div className="login-container">
      <h2 className="text-dark">{isLogin ? 'Company Login' : 'Company Registration'}</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email" className="text-dark">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={loading}
            placeholder="e.g., user@company.com"
          />
        </div>
        <div>
          <label htmlFor="password" className="text-dark">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            disabled={loading}
            placeholder="Enter password"
          />
        </div>
        {!isLogin && (
          <>
            <div>
              <label htmlFor="companyName" className="text-dark">Company Name</label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="e.g., Acme Logistics"
              />
            </div>
            <div>
              <label htmlFor="contactPerson" className="text-dark">Contact Person</label>
              <input
                type="text"
                id="contactPerson"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="e.g., John Doe"
              />
            </div>
            <div>
              <label htmlFor="phoneNumber" className="text-dark">Phone Number</label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="e.g., +27 123 456 789"
              />
            </div>
            <div>
              <label htmlFor="address" className="text-dark">Company Address</label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="e.g., 123 Main St, Durban, SA"
              />
            </div>
            <div>
              <label htmlFor="vatId" className="text-dark">VAT/Tax ID (Optional)</label>
              <input
                type="text"
                id="vatId"
                name="vatId"
                value={formData.vatId}
                onChange={handleChange}
                disabled={loading}
                placeholder="e.g., VAT123456"
              />
            </div>
            <div>
              <label htmlFor="fleetSize" className="text-dark">Fleet Size (Number of Vehicles)</label>
              <input
                type="number"
                id="fleetSize"
                name="fleetSize"
                value={formData.fleetSize}
                onChange={handleChange}
                min="0"
                required
                disabled={loading}
                placeholder="e.g., 10"
              />
            </div>
            <div>
              <label htmlFor="serviceAreas" className="text-dark">Service Areas (e.g., regions/countries)</label>
              <input
                type="text"
                id="serviceAreas"
                name="serviceAreas"
                value={formData.serviceAreas}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="e.g., Durban, SA"
              />
            </div>
            <div>
              <label htmlFor="website" className="text-dark">Website URL (Optional)</label>
              <input
                type="url"
                id="website"
                name="website"
                value={formData.website}
                onChange={handleChange}
                disabled={loading}
                placeholder="e.g., https://example.com"
              />
            </div>
          </>
        )}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <button type="submit" disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2 text-danger" role="status" aria-hidden="true"></span>
              {isLogin ? 'Logging in...' : 'Registering...'}
            </>
          ) : (
            isLogin ? 'Login' : 'Register'
          )}
        </button>
      </form>
      <div className="text-center mt-4">
        <p className="text-dark mb-0">
          {isLogin ? "Don't have an account?" : 'Already have an account?'}{' '}
          <button
            type="button"
            className="btn-link text-danger no-bg-link"
            onClick={() => setIsLogin(!isLogin)}
            disabled={loading}
          >
            {isLogin ? 'Register' : 'Login'}
          </button>
        </p>
      </div>
    </div>
  );
};

export default CompanyAuth;